export enum StatusKey {
  PLANNED = 'PLANNED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  WAITING_FOR_CANCELLATION = 'WAITING_FOR_CANCELLATION',
}
